import React from "react";

/**
 * Small presentational Stat card with soft gradient and subtle icon container
 * Usage: <StatCard title="Company Cash" value="12,345" hint="Current month" accent="from-cyan-500" />
 */
const StatCard = ({ title, value, hint, accent = "from-cyan-400" }) => {
  return (
    <div className="p-4 rounded-lg border bg-white shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs text-gray-500">{title}</div>
          <div className="mt-1 text-2xl font-bold text-slate-700">{value}</div>
          {hint && <div className="text-xs text-gray-400 mt-2">{hint}</div>}
        </div>

      </div>
    </div>
  );
};

export default StatCard;